import React, {ChangeEvent, useRef, useState} from 'react';
import DraggableVideo from 'components/DraggableVideo';

const VideoTest = () => {
  const ref = useRef<HTMLVideoElement>(null);
  const [sec, setSec] = useState<number>(0);
  return (
    <>
    <DraggableVideo/>
    <video width="400"
      controls
      autoPlay
      ref={ref}
      onTimeUpdate={(e:ChangeEvent<HTMLVideoElement>)=>{
        console.log(ref.current?.currentTime);
        if(ref.current) {
          setSec(ref.current.currentTime);
        }
      }}
    >
      <source src="https://file-examples.com/wp-content/uploads/2017/04/file_example_MP4_640_3MG.mp4" type="video/mp4"/>
    </video>
      timePlayed: {sec}
    </>
  )
}

export default VideoTest;